import { Link } from "react-router-dom";

const LINKS = [
  { label: "About", to: "/about" },
  { label: "Welcome", to: "/welcome" },
  { label: "Table", to: "/table" },
  { label: "Restore", to: "/restore" },
  { label: "Partners", to: "/partners" },
  { label: "Seasons", to: "/seasons" },
  { label: "Membership", to: "/membership" },
];

export default function Footer() {
  return (
    <footer className="relative bg-surface border-t border-white/10 pt-20 pb-10" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <Link to="/" className="flex flex-col leading-none w-max" data-testid="footer-logo">
              <span className="font-serif text-4xl md:text-5xl text-ink">Lodge &amp; Retreat</span>
              <span className="font-sans text-xs tracking-[0.4em] uppercase text-gold mt-2">
                Partners
              </span>
            </Link>
            <p className="mt-8 font-serif italic text-xl md:text-2xl text-ink/70 max-w-md">
              Private hospitality for extraordinary properties and unforgettable stays.
            </p>
          </div>

          <div className="lg:col-span-3">
            <span className="font-sans text-[0.65rem] tracking-[0.2em] uppercase text-ash">
              Explore
            </span>
            <div className="mt-5 flex flex-col gap-3">
              {LINKS.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`footer-link-${l.to.slice(1)}`}
                  className="text-left font-sans text-sm text-ink/70 hover:text-gold transition-colors duration-300"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <span className="font-sans text-[0.65rem] tracking-[0.2em] uppercase text-ash">
              Contact
            </span>
            <div className="mt-5 flex flex-col gap-3">
              <span className="font-sans text-sm text-ink/70">Wānaka · Lakes District, NZ</span>
              <a
                href="mailto:hello@lodgeandretreatpartners.nz"
                className="font-sans text-sm text-ink/70 hover:text-gold transition-colors duration-300"
              >
                hello@lodgeandretreatpartners.nz
              </a>
              <a
                href="tel:+642073035065"
                data-testid="footer-phone"
                className="font-sans text-sm text-ink/70 hover:text-gold transition-colors duration-300"
              >
                +64 207 303 5065
              </a>
              <Link
                to="/book"
                data-testid="footer-book-btn"
                className="mt-3 w-max rounded-full bg-black border border-gold/70 px-6 py-2.5 font-sans text-[0.65rem] tracking-[0.15em] uppercase text-metallic-gold hover:border-gold hover:bg-black/80 transition-all duration-300"
              >
                Get in Touch for a Chat
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="font-sans text-xs text-faint">
            © {new Date().getFullYear()} Lodge &amp; Retreat Partners. All rights reserved.
          </span>
          <span className="font-sans text-xs tracking-[0.25em] uppercase text-gold/80">
            Welcome. Table. Restore.
          </span>
        </div>
      </div>
    </footer>
  );
}
